import React, { useEffect, useRef } from 'react';
import './PopupScroll.css'; // We'll add the CSS there

const PopupScroll = ({ children }) => {
  const ref = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (ref.current === null) return
        if (entry.isIntersecting) {
          ref.current.classList.add('visible');
        } else {
          ref.current.classList.remove('visible');
        }
      },
      {
        threshold: 0.1,
      }
    );
  
    if (ref.current) {
      observer.observe(ref.current);
    }
  
    return () => {
      if (ref.current) observer.unobserve(ref.current);
    };
  }, []);

  return (
    <div className="pop-up" ref={ref}>
      {children}
    </div>
  );
};

export default PopupScroll;